import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SanitizerUtil {
  public sanitizeData(data: any): any {
    const sanitizeObject = (obj: any): any => {
      for (const key in obj) {
        if (obj[key] === null || obj[key] === undefined) {
          obj[key] = '';
        } else if (typeof obj[key] === 'object') {
          obj[key] = sanitizeObject(obj[key]);
        }
      }
      return obj;
    };

    if (Array.isArray(data)) {
      return data.map((item) => sanitizeObject(item));
    }
    return sanitizeObject(data);
  }
}
